import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { TrainingNavbar } from "./reusedcomponent/navbar";
import DatePicker from "react-datepicker";
import { ApiService } from "../../../services/ApiService";
import { Formik, Form, Field } from "formik";
import { useAlert } from "react-alert";
import Select from "react-select";

export default function EditMunch({
  closeModal,
  alert,
  users,
  getAllMuchAndLearn,
  munch,
}) {
  const [usersName, setUsersName] = useState("");
  const [usersEmail, setUsersEmail] = useState("");

  useEffect(() => {
    let emails = [];
    let names = [];
    munch &&
      munch.users_email
        .split("-")
        .map((val) => emails.push({ label: val, value: val }));
    setUsersEmail(emails);

    munch &&
      munch.name
        .split("-")
        .map((val) => names.push({ label: val, value: val }));
    setUsersEmail(emails);
    setUsersName(names);
  }, []);

  const handlePiredChange = (data) => {
    const emails = [];
    data
      ? data.map((val) => emails.push({ label: val.value, value: val.value }))
      : "";
    setUsersEmail(emails);
    setUsersName(data);
  };

  // console.log("EMAIL", usersEmail);

  console.log("munch", munch);
  return (
    <React.Fragment>
      <Formik
        initialValues={{
          name: munch.name,
          presentation_type: munch.presentation_type,
          due_date: new Date(munch.due_date),
          email: munch.email,
          users_email: munch.users_email,
          topic: munch.topic,
          id: munch.id,
        }}
        onSubmit={(values) => {
          if (values.presentation_type === "individual") {
            values.email = values.name;
            const user = users.find((u) => u.email === values.name);
            values.name = user.first_name + " " + user.last_name;
          } else if (values.presentation_type === "paired") {
            values.name = usersName;
            values.email = usersEmail;
            if (!values.name) alert.error("Presenter name is required");
            const nomerlizeName = values.name.map((obj) => obj.label);
            const nomerlizeEmail = values.email.map((obj) => obj.value);
            values.name = [...nomerlizeName];
            values.email = [...nomerlizeEmail];
          }
          ApiService.post(
            `trainings/update-munch-and-learn/${munch.id}`,
            values
          ).then((res) => {
            if (res.data.type === false) {
              alert.error(res.data.msg);
            } else if (res.data.type === true) {
              alert.success(res.data.msg);
            }
            closeModal();
            getAllMuchAndLearn();
          });
        }}
      >
        {({
          handleSubmit,
          values,
          isSubmitting,
          setFieldValue,
          handleChange,
        }) => (
          <Form>
            <div className="form-group">
              <label>
                Presentation Type <span className="text-danger"> * </span>
              </label>
              <Field
                as="select"
                className="form-control"
                id="presentation_type"
                name="presentation_type"
              >
                <option selected>--Select Presentation Type--</option>
                <option value="individual">Individual</option>
                <option value="paired">Paired</option>
                <option value="guest">Guest</option>
              </Field>
            </div>
            {values.presentation_type == "individual" ? (
              <div>
                <div className="form-group">
                  <label>
                    Presenter <span className="text-danger"> * </span>
                  </label>
                  <select
                    type="text"
                    className="form-control"
                    name="name"
                    onChange={handleChange}
                    value={values.name}
                    required
                  >
                    <option value="">--Select User--</option>

                    {users.map((user, i) => (
                      <option value={user.email} key={i}>
                        {user.first_name + " " + user.last_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>
                    Presenter Email <span className="text-danger"> * </span>
                  </label>
                  <select
                    type="text"
                    className="form-control"
                    name="email"
                    // onChange={handleChange}
                    // value={users.map((user) =>
                    //   user.id === values.name ? user.email : null
                    // )}
                    value={values.name}
                  >
                    <option value={values.name}>{values.name}</option>
                  </select>
                </div>
              </div>
            ) : null}
            {values.presentation_type == "paired" ? (
              <div>
                <div className="form-group">
                  <label>
                    Presenter <span className="text-danger"> * </span>
                  </label>
                  <Select
                    required={true}
                    isMulti
                    value={usersName}
                    options={users.map((user) => ({
                      label: user.first_name + " " + user.last_name,
                      value: user.email,
                    }))}
                    onChange={(data) => handlePiredChange(data)}
                  />
                </div>

                <div className="form-group">
                  <label id="email">
                    Presenter Email <span className="text-danger"> * </span>
                  </label>

                  <Select
                    required
                    isMulti
                    value={usersEmail}
                    isDisabled={true}
                  />
                </div>
              </div>
            ) : null}
            {values.presentation_type == "guest" ? (
              <div>
                <div className="form-group">
                  <label>
                    Presenter <span className="text-danger"> * </span>
                  </label>

                  <Field
                    type="text"
                    id="tpoic"
                    className="form-control item"
                    name="name"
                    placeholder="Enter Guest Name"
                  />
                </div>

                <div className="form-group">
                  <label>
                    Presenter Email <span className="text-danger"> * </span>
                  </label>
                  <Field as="select" className="form-control" name="email">
                    {users.map((user, i) => (
                      <option value={user.email} key={i}>
                        {user.email}
                      </option>
                    ))}
                  </Field>
                </div>
              </div>
            ) : null}
            {/* 
            <div className="form-group">
              <label>
                Email <span className="text-danger"> * </span>
              </label>
              <Field
                name="email"
                // value={values.topic}
                className="form-control item"
                placeholder="Enter Email"
              />
            </div> */}
            <div className="form-group">
              <label>
                Due Date <span className="text-danger"> * </span>
              </label>
              <div className="form-group">
                <DatePicker
                  selected={values.due_date}
                  dateFormat="MMMM d, yyyy"
                  className="form-control"
                  name="due_date"
                  minDate={new Date()}
                  onChange={(date) => setFieldValue("due_date", date)}
                />
              </div>
            </div>

            <div className="form-group">
              <label>
                Topic <span className="text-danger"> * </span>
              </label>
              <Field
                // type="text"
                id="tpoic"
                className="form-control item"
                name="topic"
                placeholder="Enter Topic"
                required
              />
            </div>
            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/trainingmanagement/edit_munch.js